// extracted by mini-css-extract-plugin
export default {"table":"styles_table__kj6gv","white_table":"styles_white_table__K602A"};